import { useState, useEffect } from "react";
import prefStyle from "./addPrefrences.module.scss";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { ReactComponent as Close } from "../../../../assets/icons/close_black_24dp.svg";

import swal from "sweetalert";

import BackDrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";

// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     border: "1px solid #6a6a6a",
//     height: "fit-content",
//     width: "100%",
//     borderRadius: "5px",
//     fontSize: "14px",
//     fontFamily: "nunito",
//     padding: "5px",
//   },
//   backdrop: { zIndex: theme.zIndex.drawer + 1, color: "#fff" },
// }));
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AddPrefrences(props) {
  // const classes = useStyles();
  const [personName, setPersonName] = useState([]);
  const [nextc, setNextc] = useState([]);
  let {
    topicData,
    setTopicData,
    topics,
    editObj,
    priceininr,
    setPriceininr,
    priceinusd,
    setPriceinusd,
    perDis,
    setPerDis,
    earlyPriceInr,
    setEarlyPriceInr,
    earlyPriceUsd,
    setEarlyPriceUsd,
    earlyDate,
    setEarlyDate,
    priceafterDisInr,
    setPriceafterDisInr,
    priceafterDisUsd,
    setPriceafterDisUsd,
    speakerArray,
    setSpeakerArray,
    courseType,
    setCourseType,
    speakerList,
    catlist,
    course_id,
    setCourse_id,
  } = props;
  const [tag, setTag] = useState("");
  const [tagArray, setTagArray] = useState([]);
  const [isLoading] = useState(false);
  const [defaultSpeaker, setDefaultSpeaker] = useState(true);

  // useEffect(() => {
  //   setTagArray(topicData.cgry_taggs);
  //   let array1 = [...topics];
  //   let pre_courseidArray = array1?.filter((val) =>
  //     topicData.pre_courseid?.includes(val?.id || val?.tid)
  //   );

  //   const preCourseName = pre_courseidArray?.map((val) => val?.tn);
  //   setPersonName(preCourseName);
  //   let nextcourseidArray = array1?.filter((val) =>
  //     topicData.nextcourseid?.includes(val?.id || val?.tid)
  //   );
  //   const newnextcourseName = nextcourseidArray?.map((val) => val?.tn);
  //   setNextc(newnextcourseName);

  //   return () => {};
  // }, [topicData.cgry_taggs, topicData.pre_courseid, topicData.nextcourseid, topics]);

  useEffect(() => {
    setTagArray(topicData.cgry_taggs || []);

    const array1 = topics || [];

    const preCourseName = array1
      .filter((val) => topicData.pre_courseid?.includes(val.id ?? val.tid))
      .map((val) => val.tn);

    setPersonName(preCourseName);

    const nextCourseName = array1
      .filter((val) => topicData.nextcourseid?.includes(val.id ?? val.tid))
      .map((val) => val.tn);

    setNextc(nextCourseName);
  }, [
    topicData.cgry_taggs,
    topicData.pre_courseid,
    topicData.nextcourseid,
    topics,
  ]);

  const onChangeHandlerTags = (event) => {
    if (tag.toString().replace(/\s/g, "")?.length === 0) {
      swal("Oops!", "Enter the tag value", "error");
      return;
    }
    let speakArray = [...tagArray];
    let obj;

    obj = tag;

    let flag = false;
    for (let j = 0; j < speakArray?.length; j++) {
      if (speakArray[j] === obj) {
        flag = true;
      }
    }
    if (flag === false) {
      speakArray.push(obj.toString());
    }

    setTagArray(speakArray);
    setTopicData((prevData) => ({ ...prevData, cgry_taggs: speakArray }));
    setTag("");
  };

  const onChangeHandlerSpeaker = (event) => {
    setDefaultSpeaker(false);

    let i = event.target.value;
    let speakArray = [...speakerArray];
    let obj;

    obj = speakerList[i].sp_id;
    let flag = false;
    for (let j = 0; j < speakArray?.length; j++) {
      if (speakArray[j] === obj) {
        flag = true;
      }
    }
    if (flag === false) {
      speakArray.push(obj);
    }

    setSpeakerArray(speakArray);
  };

  const removeTags = (value) => {
    setDefaultSpeaker(true);
    let updatedArray = [...tagArray];
    updatedArray.splice(value, 1);

    setTagArray(updatedArray);
    setTopicData((prevData) => ({ ...prevData, cgry_taggs: updatedArray }));
  };
  const removeSpeaker = (value) => {
    setDefaultSpeaker(true);
    let updatedArray = [...speakerArray];
    updatedArray = updatedArray.filter((deleting) => deleting !== value);

    setSpeakerArray(updatedArray);
  };

  const handleChange = (event) => {
    let selectArray = event.target.value;

    let temparr = [];
    for (let i = 0; i < topics?.length; i++) {
      let obj = {};

      obj.id = topics[i].id || topics[i].tid;
      obj.tn = topics[i].tn;
      for (let k = 0; k < selectArray?.length; k++) {
        if (topics[i].tn === selectArray[k]) {
          temparr.push(topics[i].id || topics[i].tid);
        }
      }
    }

    setPersonName(event.target.value);
    setTopicData((prevTopicData) => ({
      ...prevTopicData,
      pre_courseid: temparr,
    }));
  };

  const handlenextchange = (event) => {
    let selectArray = event.target.value;

    let temparr = [];
    for (let i = 0; i < topics?.length; i++) {
      let obj = {};

      obj.id = topics[i].id || topics[i].tid;
      obj.tn = topics[i].tn;
      for (let k = 0; k < selectArray?.length; k++) {
        if (topics[i].tn === selectArray[k]) {
          temparr.push(topics[i].id || topics[i].tid);
        }
      }
    }
    setNextc(event.target.value);
    setTopicData((prevTopicData) => ({
      ...prevTopicData,
      nextcourseid: temparr,
    }));
  };
  const handlesubjectchange = (event) => {
    let selectArray = event.target.value;

    setTopicData((prevTopicData) => ({
      ...prevTopicData,
      cgry_id: selectArray,
    }));
  };
  const onChangeHandlerPerDis = (event) => {
    setPerDis(event.target.value);
    let discountedPriceINR = ((100 - event.target.value) / 100) * priceininr;
    let discountedPriceUSD = ((100 - event.target.value) / 100) * priceinusd;
    if (event.target.value === "") {
      setPriceafterDisInr(0);
      setPriceafterDisUsd(0);
    } else {
      setPriceafterDisInr(discountedPriceINR);
      setPriceafterDisUsd(discountedPriceUSD);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
      <BackDrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
        className={prefStyle.backdrop}
      >
        <CircularProgress color="inherit" />
      </BackDrop>
      <Paper
        sx={{
          maxWidth: "max-content",
        }}
      >
        <div>
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>
              Navigation{" "}
              <span style={{ color: "red", marginTop: "-10px" }}>*</span> :
            </p>
            <div className={prefStyle.options}>
              <button
                className={
                  topicData.nav === "false" || topicData.nav === false
                    ? prefStyle.classtagCk
                    : prefStyle.classtag
                }
                style={{ textAlign: "center" }}
                value={true}
                disabled={!editObj.meditmode}
                onClick={(e) =>
                  setTopicData({
                    ...topicData,
                    nav: e.target.value,
                    ctype: "regular",
                  })
                }
              >
                Free
              </button>
              <button
                className={
                  topicData.nav === "true" || topicData.nav === true
                    ? prefStyle.classtagCk
                    : prefStyle.classtag
                }
                style={{ textAlign: "center" }}
                value={false}
                disabled={!editObj.meditmode}
                onClick={(e) =>
                  setTopicData({ ...topicData, nav: e.target.value })
                }
              >
                Regular
              </button>
            </div>
          </div>
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>
              {" "}
              Learning Type
              <span style={{ color: "red", marginTop: "-10px" }}>*</span> :
            </p>
            <div className={prefStyle.options}>
              <button
                className={
                  topicData.ctype === ""
                    ? prefStyle.classtagCk
                    : topicData.ctype === "enforced"
                      ? prefStyle.classtag
                      : prefStyle.classtagCk
                }
                style={{ textAlign: "center" }}
                value={"enforced"}
                disabled={
                  !editObj.meditmode ||
                  topicData.nav === true ||
                  topicData.nav === "true"
                }
                onClick={(e) =>
                  setTopicData({ ...topicData, ctype: e.target.value })
                }
              >
                Enforced
              </button>
              <button
                className={
                  topicData.ctype === ""
                    ? prefStyle.classtagCk
                    : topicData.ctype === "regular"
                      ? prefStyle.classtag
                      : prefStyle.classtagCk
                }
                style={{ textAlign: "center" }}
                value={"regular"}
                disabled={!editObj.meditmode}
                onClick={(e) =>
                  setTopicData({ ...topicData, ctype: e.target.value })
                }
              >
                Regular
              </button>
            </div>
          </div>
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>Course Id</p>
            <div className={prefStyle.options}>
              <input
                placeholder="Course Id"
                className={prefStyle.textbox}
                value={course_id}
                disabled={!editObj.meditmode}
                onChange={(e) => setCourse_id(e.target.value)}
                type="text"
              />
            </div>
          </div>
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>
              {" "}
              Prerequisites{" "}
              <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
            </p>
            <div className={prefStyle.options}>
              <button
                className={
                  topicData.pre_course === "false" ||
                  topicData.pre_course === false
                    ? prefStyle.classtagCk
                    : prefStyle.classtag
                }
                style={{ textAlign: "center" }}
                value={"true"}
                disabled={!editObj.meditmode}
                onClick={(e) =>
                  setTopicData({ ...topicData, pre_course: e.target.value })
                }
              >
                Yes
              </button>
              <button
                className={
                  topicData.pre_course === "true" ||
                  topicData.pre_course === true
                    ? prefStyle.classtagCk
                    : prefStyle.classtag
                }
                style={{ textAlign: "center" }}
                value={"false"}
                disabled={!editObj.meditmode}
                onClick={(e) =>
                  setTopicData({ ...topicData, pre_course: e.target.value })
                }
              >
                No
              </button>
            </div>
          </div>
          {topicData.pre_course === "true" || topicData.pre_course === true ? (
            <>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>
                  {" "}
                  Prerequisites Type{" "}
                  <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
                </p>
                <div className={prefStyle.options}>
                  <button
                    className={
                      topicData.pre_course_type === ""
                        ? prefStyle.classtagCk
                        : topicData.pre_course_type === "Suggestion"
                          ? prefStyle.classtag
                          : prefStyle.classtagCk
                    }
                    style={{ textAlign: "center" }}
                    value={"Suggestion"}
                    disabled={!editObj.meditmode}
                    onClick={(e) =>
                      setTopicData({
                        ...topicData,
                        pre_course_type: e.target.value,
                      })
                    }
                  >
                    Suggestion
                  </button>
                  <button
                    className={
                      topicData.pre_course_type === ""
                        ? prefStyle.classtagCk
                        : topicData.pre_course_type === "Required"
                          ? prefStyle.classtag
                          : prefStyle.classtagCk
                    }
                    style={{ textAlign: "center" }}
                    value={"Required"}
                    disabled={!editObj.meditmode}
                    onClick={(e) =>
                      setTopicData({
                        ...topicData,
                        pre_course_type: e.target.value,
                      })
                    }
                  >
                    Required
                  </button>
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>
                  {" "}
                  Prerequisites Course{" "}
                  <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
                </p>
                <div className={prefStyle.options}>
                  <FormControl className={prefStyle.formControl}>
                    <Select
                      className={prefStyle.textbox}
                      labelId="demo-mutiple-checkbox-label"
                      id="demo-mutiple-checkbox"
                      multiple
                      value={personName}
                      disabled={!editObj.meditmode}
                      onChange={handleChange}
                      input={<Input />}
                      renderValue={(selected) => {
                        selected.join(", ");
                        let temp = [];
                        for (let i = 0; i < selected?.length; i++) {
                          temp.push(selected[i]);
                        }
                        return temp;
                      }}
                      MenuProps={MenuProps}
                    >
                      {topics?.map(
                        (item) =>
                          item.tenants.length > 0 && (
                            <MenuItem key={item.id} value={item.tn}>
                              <Checkbox
                                checked={personName.indexOf(item.tn) > -1}
                              />
                              <ListItemText primary={item.tn} />
                            </MenuItem>
                          ),
                      )}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </>
          ) : null}
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>
              {" "}
              Next Course{" "}
              <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
            </p>
            <div className={prefStyle.options}>
              <button
                className={
                  topicData.nextcourse === "false" ||
                  topicData.nextcourse === false
                    ? prefStyle.classtagCk
                    : prefStyle.classtag
                }
                style={{ textAlign: "center" }}
                value={"true"}
                disabled={!editObj.meditmode}
                onClick={(e) =>
                  setTopicData({ ...topicData, nextcourse: e.target.value })
                }
              >
                Yes
              </button>
              <button
                className={
                  topicData.nextcourse === "true" ||
                  topicData.nextcourse === true
                    ? prefStyle.classtagCk
                    : prefStyle.classtag
                }
                style={{ textAlign: "center" }}
                value={"false"}
                disabled={!editObj.meditmode}
                onClick={(e) =>
                  setTopicData({ ...topicData, nextcourse: e.target.value })
                }
              >
                No
              </button>
            </div>
          </div>
          {topicData.nextcourse === "true" || topicData.nextcourse === true ? (
            <div className={prefStyle.outer}>
              <p className={prefStyle.lable}>
                {" "}
                Next Course Name{" "}
                <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
              </p>
              <div className={prefStyle.options}>
                <FormControl className={prefStyle.formControl}>
                  <Select
                    className={prefStyle.textbox}
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    multiple
                    value={nextc}
                    disabled={!editObj.meditmode}
                    onChange={handlenextchange}
                    input={<Input />}
                    renderValue={(selected) => {
                      selected.join(", ");
                      let temp = [];
                      for (let i = 0; i < selected?.length; i++) {
                        temp.push(selected[i]);
                      }
                      return temp;
                    }}
                    MenuProps={MenuProps}
                  >
                    {topics?.map(
                      (item) =>
                        item.tenants.length > 0 && (
                          <MenuItem key={item.id} value={item.tn}>
                            <Checkbox checked={nextc.indexOf(item.tn) > -1} />
                            <ListItemText primary={item.tn} />
                          </MenuItem>
                        ),
                    )}
                  </Select>
                </FormControl>
              </div>
            </div>
          ) : null}
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}> Add tags:</p>
            <div className={prefStyle.options}>
              <input
                placeholder="Tags"
                className={prefStyle.textbox}
                value={tag}
                disabled={!editObj.meditmode}
                maxLength="30"
                onChange={(e) => setTag(e.target.value)}
              />
              <button
                className={prefStyle.add}
                disabled={!editObj.meditmode}
                onClick={onChangeHandlerTags}
              >
                Add
              </button>
            </div>
          </div>
          {tagArray.length > 0 ? (
            <div className={prefStyle.outer}>
              {tagArray?.map((value, id) => {
                return (
                  <div className={prefStyle.speakertag} key={id}>
                    <h4 className={prefStyle.speakername}>{value}</h4>
                    {editObj.meditmode && (
                      <Close
                        className={prefStyle.cancelicon}
                        onClick={() => {
                          removeTags(id);
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          ) : null}
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>
              {" "}
              Tag Subject{" "}
              <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
            </p>
            <div className={prefStyle.options}>
              <FormControl className={prefStyle.formControl}>
                <Select
                  className={prefStyle.textbox}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={topicData?.cgry_id ? String(topicData.cgry_id) : ""}
                  disabled={!editObj.meditmode}
                  onChange={handlesubjectchange}
                  input={<Input />}
                  displayEmpty
                  MenuProps={MenuProps}
                >
                  <MenuItem value="" disabled>
                    Select Subject
                  </MenuItem>
                  {catlist?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          {topicData.nav === "false" || topicData.nav === false ? (
            <div className={prefStyle.outer}>
              <p className={prefStyle.lable}>
                {" "}
                Certification{" "}
                <span style={{ color: "red", marginTop: "-10px" }}>*</span> :
              </p>
              <div className={prefStyle.options}>
                <button
                  className={
                    topicData.cert === "false" || topicData.cert === false
                      ? prefStyle.classtagCk
                      : prefStyle.classtag
                  }
                  style={{ textAlign: "center" }}
                  value={"true"}
                  disabled={!editObj.meditmode}
                  onClick={(e) =>
                    setTopicData({
                      ...topicData,
                      cert: e.target.value,
                    })
                  }
                >
                  Yes
                </button>
                <button
                  className={
                    topicData.cert === "true" || topicData.cert === true
                      ? prefStyle.classtagCk
                      : prefStyle.classtag
                  }
                  style={{ textAlign: "center" }}
                  value={"false"}
                  disabled={!editObj.meditmode}
                  onClick={(e) =>
                    setTopicData({
                      ...topicData,
                      cert: e.target.value,
                    })
                  }
                >
                  No
                </button>
              </div>
            </div>
          ) : null}

          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>
              Speaker{" "}
              <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
            </p>
            <div className={prefStyle.options}>
              <select
                id="speaker"
                className={prefStyle.textbox}
                onChange={onChangeHandlerSpeaker}
                disabled={!editObj.meditmode}
              >
                <option disabled selected={defaultSpeaker}>
                  Select Speaker
                </option>
                {speakerList?.map((speaker, i) => {
                  return <option value={i}>{speaker.sp_name}</option>;
                })}
              </select>
            </div>
          </div>
          {speakerArray?.length > 0 && (
            <div className={prefStyle.outer}>
              <p className={prefStyle.lable}>Selected Speakers</p>
              <div className={prefStyle.options}>
                <div className={prefStyle.speakerlists}>
                  {/* {speakerList.map((value, id) => {
                    if (speakerArray.includes(value.sp_id)) {
                      return (
                        <div className={prefStyle.speakertag} key={id}>
                          <h4 className={prefStyle.speakername}>
                            {value.sp_name}
                          </h4>
                          {editObj.meditmode && (
                            <Close
                              className={prefStyle.cancelicon}
                              onClick={() => {
                                removeSpeaker(value.sp_id);
                              }}
                            />
                          )}
                        </div>
                      );
                    }
                  })} */}

                  {speakerList.map((value, id) => {
                    if (speakerArray.includes(value.sp_id)) {
                      return (
                        <div className={prefStyle.speakertag} key={id}>
                          <h4 className={prefStyle.speakername}>
                            {value.sp_name}
                          </h4>

                          {editObj.meditmode && (
                            <Close
                              className={prefStyle.cancelicon}
                              onClick={() => removeSpeaker(value.sp_id)}
                            />
                          )}
                        </div>
                      );
                    }

                    return null; // ✅ fixes ESLint warning
                  })}
                </div>
              </div>
            </div>
          )}
          <div className={prefStyle.outer}>
            <p className={prefStyle.lable}>
              Course Type
              <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
            </p>
            <div className={prefStyle.options}>
              <select
                id="coursetype"
                disabled={!editObj.meditmode}
                className={prefStyle.textbox}
                onChange={(e) => setCourseType(e.target.value)}
                value={courseType}
              >
                <option value="free">Free</option>
                <option value="paid">Paid</option>
              </select>
            </div>
          </div>
          {courseType === "paid" ? (
            <div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>
                  Price in INR{" "}
                  <span style={{ color: "red", marginTop: "-10px" }}>*</span>:
                </p>
                <div className={prefStyle.options}>
                  <input
                    placeholder="Price in INR"
                    type="number"
                    className={prefStyle.textbox}
                    disabled={!editObj.meditmode}
                    value={priceininr}
                    min="0"
                    onChange={(e) => setPriceininr(e.target.value)}
                  />
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>Price in USD</p>
                <div className={prefStyle.options}>
                  <input
                    placeholder="Price in USD"
                    type="number"
                    disabled={!editObj.meditmode}
                    className={prefStyle.textbox}
                    min="0"
                    value={priceinusd}
                    onChange={(e) => setPriceinusd(e.target.value)}
                  />
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>Percentage Discount</p>
                <div className={prefStyle.options}>
                  <input
                    type="number"
                    placeholder="Discount"
                    className={prefStyle.textbox}
                    onChange={onChangeHandlerPerDis}
                    disabled={!editObj.meditmode}
                    value={perDis}
                    min="0"
                  />
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>Price after Discount INR</p>
                <div className={prefStyle.options}>
                  <input
                    placeholder="Price after discount INR"
                    className={prefStyle.textbox}
                    disabled={!editObj.meditmode}
                    value={priceafterDisInr}
                  />
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>Price after Discount USD</p>
                <div className={prefStyle.options}>
                  <input
                    placeholder="Price after discount USD"
                    className={prefStyle.textbox}
                    value={priceafterDisUsd}
                    disabled={!editObj.meditmode}
                  />
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>Early Birds Date</p>
                <div className={prefStyle.options}>
                  <input
                    type="date"
                    className={prefStyle.textbox}
                    disabled={!editObj.meditmode}
                    value={moment(earlyDate).format("YYYY-MM-DD")}
                    onChange={(e) => setEarlyDate(e.target.value)}
                  />
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>Early Birds Price INR</p>
                <div className={prefStyle.options}>
                  <input
                    type="number"
                    className={prefStyle.textbox}
                    value={earlyPriceInr}
                    disabled={!editObj.meditmode}
                    onChange={(e) => setEarlyPriceInr(e.target.value)}
                    min="0"
                  />
                </div>
              </div>
              <div className={prefStyle.outer}>
                <p className={prefStyle.lable}>Early Birds Price USD</p>
                <div className={prefStyle.options}>
                  <input
                    type="number"
                    className={prefStyle.textbox}
                    value={earlyPriceUsd}
                    disabled={!editObj.meditmode}
                    onChange={(e) => setEarlyPriceUsd(e.target.value)}
                    min="0"
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </Paper>
    </div>
  );
}
